<template>
  <m-a class="edit-item-1" :href="{name:selectedType,params:{...routerParams}}" v-if="showToolbar">
    <m-icon icon="pencil" class="text-dark edit-item-1-icon"/>
  </m-a>
</template>

<script>
/*
* this component can be use on product, any content(post, page and lesson) and course to
* redirect user to edit mode of that item in dashboard.
*
* */
import {mapGetters} from "vuex";
import {findRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/RouterFunctions'
import {dashboardRoutes} from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/routes/DashboardRoutes'

export default {
  name: "Toolbar1",
  data() {
    return {
      supportedRoutes: {
        'Product': 'EditProduct',
        'SinglePost': 'UpdateContent',
        'SinglePage': 'UpdateContent',
        'SingleLesson': 'UpdateLessons',
        'SingleCourse': 'EditCourse',
      }
    }
  },
  computed: {
    ...mapGetters({
      'isAdmin': 'User/isAdmin'
    }),
    routerParams() {

      const dashboardRoute = this.findRoutes(dashboardRoutes, [this.selectedType])[0];
      let params = {};

      dashboardRoute.path.split('/').forEach(item => {
        if (item.indexOf(':') > -1) {
          params[item.replace(':', '')] = this.selectedType == 'EditProduct' ? this.$route.params.name : this.$route.params.slug
        }
      })
      return params


    },
    selectedType() {
      return this.supportedRoutes[this.$route.name]
    },
    showToolbar() {
      return this.isAdmin && this.selectedType != undefined
    }
  },
  methods: {
    findRoutes,
  }
}
</script>

<style scoped>
.edit-item-1 {
  background: var(--primary);
  top: auto;
  right: auto;
  left: 30px;
  bottom: 50px;
  z-index: 1;
  position: fixed;
  width: 5%;
  height: 40px;
  font-size: 25px;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 50px;
}

.edit-item-1-icon .edit-item-1-icon {
  background: var(--primary);
}

</style>